















import Candle from "@/models/candle";
import CandleInfo from "./CandleInfo.vue";
import SocialMedia from './SocialMedia.vue';
import Icon from "./Icon.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    CandleInfo,
    SocialMedia,
    Icon
  },
})
export default class AboutView extends Vue {
  private candle: Candle = {
    name: "Leo Burgman",
  };
}
